import Treasury from "../../assets/icons/Treasury.png";
import Accounts from "../../assets/icons/Accounts.png";
import E_Doc from "../../assets/icons/E-Doc.png";
import Wallets from "../../assets/icons/Wallets.png";

import { Link } from "react-router-dom";
import { useLanguage } from "../../i18n/LanguageContext";

const dropdownBase =
  "bg-white rounded-xl border border-gray-100 shadow-lg shadow-blue/10 overflow-hidden min-w-[220px] py-1";
const linkBase =
  "flex items-center gap-3 px-5 py-3 text-sm text-darkBlue/80 hover:bg-blue/5 hover:text-blue transition-colors duration-150";
const linkIcon = "w-9 h-9 object-contain shrink-0";

export const WhyUs = () => {
  const { t } = useLanguage();
  return (
    <ul className={dropdownBase}>
      <li>
        <Link to="/ourCompany" className={linkBase}>
          {t("nav.items.ourCompany")}
        </Link>
      </li>
      <li>
        <Link to="/ourMission" className={linkBase}>
          {t("nav.items.ourMission")}
        </Link>
      </li>
    </ul>
  );
};

export const Products = () => {
  const { t } = useLanguage();
  return (
    <ul className={dropdownBase}>
      <li>
        <Link to="/products/treasury" className={linkBase}>
          <img src={Treasury} alt="Treasury" className={linkIcon} />
          {t("nav.items.treasury")}
        </Link>
      </li>
      <li>
        <Link to="/products/virtual-account" className={linkBase}>
          <img src={Accounts} alt="Virtual Accounts" className={linkIcon} />
          {t("nav.items.virtualAccounts")}
        </Link>
      </li>
      <li>
        <Link to="/products/e-wallets" className={linkBase}>
          <img src={Wallets} alt="E-Wallets" className={linkIcon} />
          {t("nav.items.eWallets")}
        </Link>
      </li>
      <li>
        <Link to="/products/invoice-QR-Integration" className={linkBase}>
          <img src={E_Doc} alt="Invoice QR" className={linkIcon} />
          {t("nav.items.invoiceQr")}
        </Link>
      </li>
    </ul>
  );
};

export const Solutions = () => {
  const { t } = useLanguage();
  return (
    <ul className={dropdownBase}>
      <li>
        <Link to="/solutions#b2b-payments" className={linkBase}>
          {t("nav.items.b2bPayments")}
        </Link>
      </li>
      <li>
        <Link to="/solutions#order-to-cash" className={linkBase}>
          {t("nav.items.orderToCash")}
        </Link>
      </li>
      <li>
        <Link to="/solutions#record-to-report" className={linkBase}>
          {t("nav.items.recordToReport")}
        </Link>
      </li>
      <li>
        <Link to="/solutions#cash-management" className={linkBase}>
          {t("nav.items.cashManagement")}
        </Link>
      </li>
      <li>
        <Link to="/solutions#account-payables" className={linkBase}>
          {t("nav.items.accountPayables")}
        </Link>
      </li>
    </ul>
  );
};

export const Resources = () => {
  const { t } = useLanguage();
  return (
    <ul className={dropdownBase}>
      <li>
        <Link to="/usecase" className={linkBase}>
          {t("nav.items.useCases")}
        </Link>
      </li>
    </ul>
  );
};

export const ContactUs = () => {
  const { t } = useLanguage();
  return (
    <ul className={dropdownBase}>
      <li>
        <Link to="/contact" className={linkBase}>
          {t("nav.sections.contact")}
        </Link>
      </li>
    </ul>
  );
};
